import styles from './cart-page.module.scss'
import cl from 'classnames'
import { observer } from 'mobx-react-lite'
import { Button, Checkbox, PageContainer } from '@touche-lts/panel-ui/dist'
import { IconCart } from 'assets/icons'
import { useEffect } from 'react'
import { useRootStore } from 'mobx-stores/store-provider'

const CartComponent = () => { 

  const {
    cartCheckoutStore: {
      getCartByUserId,
      cartStoreProducts,
      deleteCartByProductId,
      updateCartByProductId,
      cartStoreProductsSize,
      checkCartProduct,
      checkAllProductsByStore,
      orderSummary,
      isAllProductValidForShopifyCheckout
    },
    routingStore: { push }
  } = useRootStore(),

  userDetailsId = JSON.parse(localStorage.getItem('userDetails'))?.id,

  handleColorCheck = (color: string): boolean => {
    return color.startsWith('#') && color.length<=9
  },

  isImageUrlAVideo = (imageUrl: string): boolean => {
    if(!!imageUrl) {
      return imageUrl.includes('.mp4')
    }
    return false;
  },

  handleDeleteProduct = (productId: string | number): void => {
    deleteCartByProductId(userDetailsId, productId)
  },

  handleCountAddPlus = (productDetails: any): void => {
    if (productDetails.count + 1 <= productDetails.sku.stock) {
    productDetails.count++;
    updateCartByProductId(userDetailsId, productDetails)
    }
  },
  
  handleCountAddMinus = (productDetails: any): void => {
    if(productDetails.count > 1) {
      productDetails.count--;
      updateCartByProductId(userDetailsId, productDetails)
    }
  },

  checkProduct = (productDetails: any): void => {
    productDetails.checked = !productDetails.checked;
    checkCartProduct(userDetailsId, productDetails)
  },

  handleAllProductsChecked = (storeName: string): boolean => {
    return cartStoreProducts[storeName].map(product => product.checked).every(checkedValue => checkedValue)
  },

  handleProceedToCheckout = (): void => {
    if (!isAllProductValidForShopifyCheckout) {
      return;
    }
    const isTempUser = JSON.parse(localStorage.getItem('isTempUser'));
    if(isTempUser) {
      push('/login')
      return;
    }
    push('/checkout')
  },

  dropDownIndicatorStyle = {
    dropdownIndicator: base => ({
      ...base,
      color: "white",
      marginRight: 10
    })
  }

  useEffect(()=> {
    getCartByUserId(userDetailsId)
  }, [getCartByUserId, userDetailsId])

  return (
    <PageContainer className={cl(styles.scrollable, 'container',"overflow-hidden")} style={{marginTop: 80}}>
      <div className="row">
        <div className="col-lg-7 mb-3">
          <h2 className={styles.shippingCartHeader}>
            Shopping cart ({cartStoreProductsSize})
          </h2>
          {cartStoreProducts && !!Object.keys(cartStoreProducts).length && Object.keys(cartStoreProducts).reverse().map(storeName => {
            const isShopifyProduct = cartStoreProducts[storeName]?.[0]?.product?.shopifyId;
            return (
              <div className={styles.shoppingCartBox} key={storeName}>
                <div className={styles.storeHeader}>
                  <div className={styles.storeHeaderLeft}>
                    <Checkbox isChecked={handleAllProductsChecked(storeName)} onClick={() => checkAllProductsByStore(userDetailsId, storeName)}/>
                    <p>{storeName}</p>
                  </div>
                  {isShopifyProduct ? (
                    <span className={styles.shopifyProductBadge}>Shopify Product</span>
                  ) : null}
                </div>
                <hr />
                {cartStoreProducts[storeName].map((productDetails, indexDetails) => {
                  return (
                      <div className="row" key={indexDetails}>
                        <div className="col-lg-3">
                          <div className={styles.storeProductCheckboxImage}>
                            <Checkbox isChecked={productDetails?.checked} onClick={() => checkProduct(productDetails)}/>
                            {productDetails?.product?.images && !!productDetails?.product?.images.length && (
                              isImageUrlAVideo(productDetails?.product?.images[0]?.url) ? 
                              <video>
                                <source src={productDetails?.product?.images[0]?.url} />
                              </video> :
                              <img src={productDetails?.product?.images[0]?.url} alt="Product Details" />
                            )}
                          </div>
                        </div>
                        <div className="col-lg-6">
                            <h4 className={styles.productHeader}>
                              {productDetails?.product?.name}
                            </h4>
                            <p className={styles.productPrice}>
                            {productDetails?.sku?.curr} {productDetails?.price}
                            </p>
                            {productDetails?.sku?.attributes && productDetails?.sku?.attributes.map(attr => {
                              return (
                                <p className={styles.productAttributes} key={attr?.value}>
                                {attr?.name}: {handleColorCheck(attr?.value) 
                                ? <span className={styles.dotDynamic} style={{backgroundColor: attr?.value}}></span> : attr?.value}
                                </p>
                              )
                            })}
                            <div className={styles.shippingProductSelect}>
                              <p>Shipping</p>
                              <p className="my-3">{productDetails?.shipping?.name} - {productDetails?.shipping?.currency} {productDetails?.shipping?.price}</p>
                              {/* <select className={cl(styles.selectShipping, dropDownIndicatorStyle)}>
                                {productDetails?.product?.shippings.map((shipping, indexShipping) => {
                                  return (
                                    <>
                                      {indexShipping === 0 && (
                                        <option selected value={shipping?.id}>{shipping?.name} - {shipping?.currency} {shipping?.price}</option>
                                      )}
                                      {indexShipping > 0 && (
                                        <option value={shipping?.id}>{shipping?.name} - {shipping?.currency} {shipping?.price}</option>
                                      )}
                                    </>
                                  )
                                })}
                              </select> */}
                            </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="d-flex flex-column align-items-end">
                            <div className={styles.quantityCount}>
                                <span onClick={() => handleCountAddMinus(productDetails)}>-</span>
                                <p className={styles.quantity}>{productDetails?.count}</p>
                                <span className={productDetails?.sku?.stock <= 1 ? styles.disableBehavior : ''} onClick={() => handleCountAddPlus(productDetails)}>+</span>
                            </div>
                            <p onClick={() => handleDeleteProduct(productDetails?.id)} className={styles.removeItem}>Remove item</p>
                            <p className={styles.skuInfo}>SKU: {productDetails?.sku?.sku}</p>
                            {productDetails.count === productDetails.sku.stock && <p className={styles.quantityError}>Maximum quantity available</p>}
                          </div>
                        </div>
                        {cartStoreProducts[storeName].length > 1 && indexDetails <= cartStoreProducts[storeName].length - 2 && 
                        (<hr style={{color: 'white', margin: '10px 0px'}} />)}
                      </div>
                  )
                })}
              </div>
            )
          })}
        </div>
        <div className="col-lg-5">
          <div className="d-flex">
            <IconCart  style={{ fill: 'white' }}/>
            <h4 className={styles.orderSummaryHeader}>Order summary</h4>
          </div>
          <div className={styles.orderSummaryBox}>
            <div className={styles.orderSummaryContent}>
              <p>Items ({orderSummary.items})</p>
              <p>US ${orderSummary.itemsTotal}</p>
            </div>
            <div className={styles.orderSummaryContent}>
              <p>Shipping fee</p>
              <p>US ${orderSummary.shippingFee}</p>
            </div>
            <hr />
            <div className={styles.orderSummaryContentTotal}>
              <p>Total to pay</p>
              <p>US ${orderSummary.totalToPay}</p>
            </div>
            <Button 
              className={cl(styles.proceedToCheckOutBtn, (orderSummary.items === 0 || !isAllProductValidForShopifyCheckout) ? styles.disableBehavior : '')} 
              preset='primary' 
              onClick={handleProceedToCheckout}
            >
               Proceed to Checkout ({orderSummary.items})
            </Button>
            {!isAllProductValidForShopifyCheckout ? (
              <p className={styles.shopifyMixedCartError}>
                You can't proceed to checkout with store product and shopify product at the same time.
              </p>
            ) : null}
          </div>
        </div>
      </div>
    </PageContainer>
  )
},

CartPage = observer(CartComponent)
export { CartPage }
